import React, {useState} from "react";
import OdxModal from "../../../../OdxComponents/NativeOdx/Modal/Odx-Modal";
import {odxVariants} from "../../../../OdxComponents/constants";
import OdxRadioButton from "../../../../OdxComponents/NativeOdx/FormControls/Odx-RadioButton";
import OdxChip from "../../../../OdxComponents/NativeOdx/Odx-Chip";
import {simplifyForHtmlId} from "../../../../Utils/transformer";


interface DeleteProjectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onDelete: (deleteType: "hard" | "soft") => void;
    projectName: string;
}

const DeleteProjectModal: React.FC<DeleteProjectModalProps> = ({
                                                                   isOpen,
                                                                   onClose,
                                                                   onDelete,
                                                                   projectName,
                                                               }) => {
    const [deleteType, setDeleteType] = useState<"hard" | "soft">("soft");
    const baseId = `project-delete-${simplifyForHtmlId(projectName)}`;

    const handleDelete = () => {
        onDelete(deleteType);
        onClose();
    };

    return (
        <OdxModal
            size="small"
            variant="default"
            title={`Delete ${projectName}`}
            onClose={onClose}
            isOpen={isOpen}
            id={baseId}
            footerButtons={[
                <odx-button
                    key="cancel"
                    variant="ghost"
                    size="lg"
                    onClick={onClose}
                    id={`${baseId}-cancel-btn`}
                >
                    Cancel
                </odx-button>,
                <odx-button
                    key="delete"
                    variant="danger"
                    size="lg"
                    id={`${baseId}-delete-btn`}
                    onClick={handleDelete}
                >
                    Delete
                </odx-button>,
            ]}
        >
            <div id={`${baseId}-content`}>
                {/* Soft Delete Option */}
                <OdxRadioButton
                    name="deleteType"
                    value="soft"
                    label="Soft Delete"
                    id={`${baseId}-soft-option`}
                    checked={deleteType === "soft"}
                    onChange={() => setDeleteType("soft")}
                    description="This will delete the project but keep the modules preserved."
                    className="mb-4"
                />
                <div className="flex items-center mb-4">
                    <OdxChip
                        size="small"
                        variant={odxVariants.highlight}
                        content="Recommended"
                        id={`${baseId}-soft-chip`}
                    />
                </div>

                <odx-separator style={{margin: '1rem 0'}} />

                {/* Hard Delete Option */}
                <OdxRadioButton
                    name="deleteType"
                    value="hard"
                    id={`${baseId}-hard-option`}
                    label="Hard Delete"
                    checked={deleteType === "hard"}
                    onChange={() => setDeleteType("hard")}
                    description="This will delete the project and all its modules permanently."
                    className="mt-4"
                />
            </div>
        </OdxModal>
    );
};

export default DeleteProjectModal;
